import { ExportInvoiceOrderReq } from '@models/booking.model';

export type RegisterRequest = {
    Email: string;
    FullName: string;
    Phone: string;
    FirstName: string;
    LastName: string;
    PasswordStr?: string;
    Password: string;
};

export type SignInRequest = {
    Account: string;
    Password: string;
    PasswordByte?: string;
    CaptchaToken?: string;
    Captcha?: string;
    LoginFailNumber?: number;
};

export type SessionResponse = {
    ID: number;
    Message: string;
    SessionKey: string;
    UserInfo: Session;
};

export type Session = {
    UserId: number;
    UserKey: string;
    UserCode: string;
    IsPrimary: boolean;
    Gender: string;
    FullName: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Phone: string;
    Address: string;
    PartnerBalanceAmount: number;
    PartnerId: number;
    PartnerKey: string;
    IsSupperAdmin: boolean;
    UserStatus: boolean;
    IsLocked: boolean;
    PartnerStatus: boolean;
    PositionId: number;
    UserToken: string;
    IPAddress: string;
    BookerId: string;
    IsTokenIssueAndTicket: boolean;
    Birthday: string;
    MethodSignup: string;
    ProfilePictureUrl: string;
    InvoiceInfo: ExportInvoiceOrderReq;
    IsReceiveCampaignNotifications: boolean;
};

export type AuthStateEvent = {
    platform: 'google' | 'facebook';
    token: string;
};

export enum AccountVerificationStep {
    Success = 'Success',
    Failure = 'Failure',
    ResendSuccess = 'ResendSuccess',
    ResendFailure = 'ResendFailure',
}

export type GoogleSignInButton = Pick<HTMLButtonElement, 'click' | 'remove'> & {
    error: string;
};

export enum ResetPasswordStep {
    TokenInvalid = 'token-invalid',
    TokenValid = 'token-valid',
    ResetPWSuccess = 'reset-pw-success',
}

export interface ChangePasswordRequest {
    Token: string;
    NewPassword: string;
}
